import PropTypes from 'prop-types';

const Tab = ({ children }) => children;

Tab.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Tab;
